import React from "react"
import {
    EditorInFocus,
    DirectiveNode,
    ConditionalContents,
    Separator,
    BlockTypeSelect,
    BoldItalicUnderlineToggles,
    StrikeThroughSupSubToggles,
    ChangeCodeMirrorLanguage,
    CodeToggle,
    DiffSourceToggleWrapper,
    InsertAdmonition,
    ChangeAdmonitionType,
    InsertCodeBlock,
    InsertImage,
    InsertTable,
    InsertThematicBreak,
    ListsToggle,
    UndoRedo,
    CreateLink,
    ViewMode
} from "@mdxeditor/editor";

function whenInAdmonition(editorInFocus: EditorInFocus | null) {
    const node = editorInFocus?.rootNode
    if (!node || node.getType() !== "directive") {
        return false
    }

    return ["note", "tip", "danger", "info", "caution"].includes((node as DirectiveNode).getMdastNode().name as any)
};

export type RichTextEditorToolbarProps = {
    availableViews: ViewMode[],
};

export const QerentRichTextEditorToolbar: React.FC<RichTextEditorToolbarProps> = ({ availableViews }) => {
    return (
        <DiffSourceToggleWrapper options={availableViews}>
            <ConditionalContents
                options={[
                    { when: (editor) => editor?.editorType === "codeblock", contents: () => <ChangeCodeMirrorLanguage /> },
                    {
                        fallback: () => (
                            <>
                                <UndoRedo />
                                <Separator />
                                <BoldItalicUnderlineToggles />
                                <CodeToggle />
                                <Separator />
                                <StrikeThroughSupSubToggles />
                                <Separator />
                                <ListsToggle />
                                <Separator />

                                <ConditionalContents
                                    options={[{ when: whenInAdmonition, contents: () => <ChangeAdmonitionType /> }, { fallback: () => <BlockTypeSelect /> }]}
                                />

                                <Separator />

                                <CreateLink />
                                <InsertImage />

                                <Separator />

                                <InsertTable />
                                <InsertThematicBreak />

                                <Separator />
                                <InsertCodeBlock />

                                <Separator />
                            </>
                        )
                    }
                ]}
            />
        </DiffSourceToggleWrapper>
    )
}